import React, { Component } from 'react'
import Slider from 'react-slick'
import { ModalIconHelpPlaySVG } from 'assets/svg/ModalSVG/ModalIconHelpPlaySVG'

export default class ContentModalHelpMobile extends Component {
	render() {
		const settings = {
			dots: true,
			infinite: true,
			speed: 100,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
		}
		return (
			<div>
				<Slider {...settings}>
					{this.props.data.map((it, i) => (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<img
								className="img-mobile"
								style={{ margin: 'auto' }}
								width={'100%'}
								src={it.img}
								alt=""
							/>
							<div className="text">
								<h5>{`ຂັ້ນຕອນ${i + 1}`}</h5>
								<ModalIconHelpPlaySVG
									width="18"
									height="4"
									viewBox="0 0 18 4"
								/>
								<p>{it.text}</p>
							</div>
						</div>
					))}
				</Slider>
			</div>
		)
	}
}
